import React, { useEffect } from 'react';
import {
  Col, message, useAppDispatch, useAppSelector, useNavigate, useTranslation, BasicButtonBG,
  roleService,
} from '@lib/index';
import { useAuth0 } from '@auth0/auth0-react';
import {
  assignLoginType,
  assignRole,
  clearState,
  getRolePermissions,
} from '@features/account/AccountSlice';

const Auth0LoginControls = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { currentUser } = useAppSelector((state) => state.account);
  const { kitchen } = currentUser;
  const { t } = useTranslation();
  const { useLoginRoleWithAuthTokenMutation } = roleService;
  const [loginRoleWithAuthToken] = useLoginRoleWithAuthTokenMutation();
  const {
    isAuthenticated: isAuth0Authenticated,
    error: authError,
    loginWithPopup,
    getAccessTokenSilently,
  } = useAuth0();

  const handleAuth0TokenGeneration = async () => {
    try {
      const token = await getAccessTokenSilently();
      const response = await loginRoleWithAuthToken({ token }).unwrap();
      await dispatch(assignRole(response));
      dispatch(assignLoginType('auth0'));
      await dispatch(getRolePermissions(response.token as string));
    } catch {
      message.warning(t('login.loginError'), 5);
      return;
    }
    dispatch(clearState());
  };

  useEffect(() => {
    if (isAuth0Authenticated) {
      handleAuth0TokenGeneration();
    }

    if (authError) {
      message.warning(t('login.loginError'), 5);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuth0Authenticated, authError]);

  useEffect(() => {
    if (isAuth0Authenticated && kitchen) {
      navigate('/dashboard');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuth0Authenticated, kitchen]);

  useEffect(() => {
    if (!kitchen) {
      dispatch(assignLoginType(''));
    }
  }, [dispatch, kitchen]);

  const loginWithAuth0 = async () => {
    await dispatch(assignLoginType('auth0'));
    loginWithPopup();
  };

  return (
    <Col xs={24}>
      <BasicButtonBG
        size="large"
        className="mt-4"
        data-cy="login-form-auth0"
        onClick={loginWithAuth0}
        buttonColorType="default"
        text={t('login.contractorEnter')}
        loading={false}
        type="primary"
      />
    </Col>
  );
};

export default Auth0LoginControls;
